import { useEvent } from 'hooks'
import $ from 'jquery'
import { debounce } from 'utils'
import { global } from '../constant/global'

export const makeFormData = (param: { [key: string]: any }) => {
	const formData = new FormData()
	const keys = Object.keys(param)
	const values = Object.values(param)

	for (let i = 0, { length } = keys; i < length; i++) {
		const key = keys[i]
		const value = values[i]
		if (Array.isArray(value)) {
			for (let j = 0, arrLength = value.length; j < arrLength; j++) {
				formData.append(`${key}[]`, value[j])
			}
		} else {
			formData.append(key, value)
		}
	}

	return formData
}

export const addSaveOnChangeHandler = (
	target: HTMLInputElement | NodeListOf<HTMLInputElement> | null,
	dataKey: string | null = null,
	dataCallback: ((element: HTMLInputElement, value: string | boolean) => object) | null = null,
) => {
	if (target === null) {
		return
	}

	const addListener = (element: HTMLInputElement) => {
		const change = useEvent(element, 'change')
		change.register(
			debounce(() => {
				const value = element.type === 'checkbox' ? element.checked : element.value

				let dataObject: object

				if (dataCallback !== null) {
					dataObject = dataCallback(element, value)
				} else if (dataKey !== null) {
					dataObject = {
						[dataKey]: value,
					}
				} else {
					dataObject = { value }
				}

				// @ts-ignore
				$.nette.ajax({
					type: 'POST',
					url: element.getAttribute(global.editorComponentChangeHandler),
					data: dataObject,
				})
			}),
		)
	}

	if (target instanceof HTMLInputElement) {
		addListener(target)
	} else {
		target.forEach((e) => addListener(e))
	}
}
